import { Button, Container, Divider, Text } from "@mantine/core";
import YoutubeImage from "../../../Assets/IMG/services/home/Youtube.png";
import NetflixImage from "../../../Assets/IMG/services/home/Netflix.png";
import PrimeImage from "../../../Assets/IMG/services/home/Prime.png";
import SpotifyImage from "../../../Assets/IMG/services/home/Spotify.png";
import ShowmaxImage from "../../../Assets/IMG/services/home/Showmax.png";
import DuolingoImage from "../../../Assets/IMG/services/home/Duolingo.svg";
import GoogleOneImage from "../../../Assets/IMG/services/home/GoogleOne.png";
import AppleMusicImage from "../../../Assets/IMG/services/home/apple_music.png";
import { AppName, Colors } from "../../../Lib/Data";
import { getFinancialValueFromNumeric } from "../../../Lib/Methods";

import "./styles.scss";
import { Link } from "react-router-dom";

export default function HomeBanners() {
  const Slides = [
    {
      image: NetflixImage,
      price: 2300,
      text: [
        `Experience the world of limitless entertainment with Netflix. From the latest blockbuster movies to gripping TV shows, documentaries, and exclusive Netflix Originals, there's something for everyone. `,
        `Stream in high-definition, enjoy personalized recommendations, and dive into a massive library of entertainment, anytime, anywhere.`,
        `Get your Netflix subscription today with ${AppName} and enjoy endless hours of entertainment!`,
      ],
      title: `Netflix`,
      colour: `#E50914`,
    },
    {
      image: SpotifyImage,
      price: 950,
      text: [
        `Discover a world of music with Spotify, the ultimate music streaming service. From the hottest tracks to classic albums and personalized playlists, Spotify offers something for every music lover. `,
        `With ${AppName}, you can get Spotify Premium at unbeatable prices, unlocking ad-free listening, offline downloads, and higher sound quality.`,
        `Start listening to the music you love without limits. Get your Spotify Premium subscription today with ${AppName} and elevate your music experience!`,
      ],
      title: `Spotify`,
      colour: `#1ABC54`,
    },
    {
      image: ShowmaxImage,
      price: 1200,
      text: [
        `Dive into a world of movies, series, sports, and kids' shows, all in one place. With Showmax on ${AppName}, you enjoy affordable access to top-tier content all streaming on your favorite devices.`,
        `Whether you're binge-watching series or catching up on the latest matches, Showmax keeps you entertained without limits.`,
      ],
      title: `Showmax`,
      colour: `#1E1E1E`,
    },
    {
      image: AppleMusicImage,
      price: 2500,
      text: [
        `Dive into a world of over 100 million songs, expertly curated playlists, and exclusive artist content. With Apple Music on ${AppName}, enjoy ad-free streaming, offline listening, and lossless audio at a fraction of the cost. Whether you're vibing solo or joining a family plan, experience premium music without the premium price.`,
      ],
      title: `Apple Music`,
      colour: `#FA233B`,
      // colour: `#FA233B`,
    },
    {
      image: DuolingoImage,
      price: 1200,
      text: [
        "With Duolingo Super, you get access to an ad-free experience, unlimited hearts, offline courses, and more. It's the best way to take your language learning to the next level. ",
        " ",
        "Whether you're learning Spanish, French, or Japanese, Duolingo Super ensures you can practice anytime, anywhere, without interruptions.",
      ],
      title: "Duolingo Super",
      colour: "#58CC02",
    },
    {
      image: GoogleOneImage,
      price: 1099,
      text: [
        "Get more storage and cloud backup for all your files with Google One. Store your photos, videos, and documents securely in the cloud and access them from any device. ",
      ],
      title: "Google One",
      colour: "#4285F4",
    },
  ];
  return (
    <div className="home-banners-container" id="banners">
      <div className="content">
        {Slides.map((slide, index) => {
          return (
            <div
              className="slide-container width-100"
              style={
                {
                  "--slide-color": slide.colour,
                } as React.CSSProperties
              }
            >
              <Container size="lg">
                <div
                  key={slide.title}
                  className={`slide flex-row align-center justify-between ${
                    index % 2 === 0 ? "ltr" : "rtl"
                  }`}
                >
                  <div className="left flex-col align-center justify-center">
                    <img src={slide.image} alt="" className="image" />
                    <Text className="price-label">Get Now</Text>
                    <Text className="price-value" fw={800}>
                      ${getFinancialValueFromNumeric(slide.price)}
                    </Text>
                  </div>
                  <Divider className="divider" />
                  <div className="right flex-col">
                    {slide.text.map((t) => {
                      return (
                        <Text key={t} className="text">
                          {t}&nbsp;
                        </Text>
                      );
                    })}
                    <Link to="/d/services">
                      <Button
                        h={45}
                        w={190}
                        className="btn"
                        style={{
                          backgroundColor: slide.colour,
                          color: "#fff",
                        }}
                      >
                        <Text className="label">Get {slide.title}</Text>
                      </Button>
                    </Link>
                  </div>
                </div>
              </Container>
            </div>
          );
        })}
      </div>
    </div>
  );
}
